module.exports = __webpack_public_path__ + "static/media/footerbg.560f8cb4.webp";